import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import "./App.css";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";

import ClientDashboard from "./pages/client/ClientDashboard";
import ClientSearch from "./pages/client/ClientSearch";
import ClientBooking from "./pages/client/ClientBooking";
import BoardingPass from "./pages/client/BoardingPass";
import ClientProfile from "./pages/client/ClientProfile";
import ClientHistory from "./pages/client/ClientHistory";
import ClientRatings from "./pages/client/ClientRatings";
import ClientSavedPreferences from "./pages/client/ClientSavedPreferences";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminDrivers from "./pages/admin/AdminDrivers";
import AdminRoutes from "./pages/admin/AdminRoutes";
import AdminReservations from "./pages/admin/AdminReservations";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminIntegrations from "./pages/admin/AdminIntegrations";
import AdminReports from "./pages/admin/AdminReports";

import DriverDashboard from "./pages/driver/DriverDashboard";
import DriverRoute from "./pages/driver/DriverRoute";
import DriverRoutesManage from "./pages/driver/DriverRoutesManage";
import DriverProfile from "./pages/driver/DriverProfile";
import DriverHistory from "./pages/driver/DriverHistory";
import DriverRatings from "./pages/driver/DriverRatings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />

            {/* Cliente */}
            <Route element={<ProtectedRoute allowedRoles={["cliente"]}><Outlet /></ProtectedRoute>}>
              <Route path="/cliente" element={<ClientDashboard />} />
              <Route path="/cliente/buscar" element={<ClientSearch />} />
              <Route path="/cliente/reservar" element={<ClientBooking />} />
              <Route path="/cliente/ticket" element={<BoardingPass />} />
              <Route path="/cliente/historial" element={<ClientHistory />} />
              <Route path="/cliente/perfil" element={<ClientProfile />} />
              <Route path="/cliente/calificaciones" element={<ClientRatings />} />
              <Route path="/cliente/preferencias" element={<ClientSavedPreferences />} />
            </Route>

            {/* Admin */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]}><Outlet /></ProtectedRoute>}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/conductores" element={<AdminDrivers />} />
              <Route path="/admin/rutas" element={<AdminRoutes />} />
              <Route path="/admin/reservas" element={<AdminReservations />} />
              <Route path="/admin/usuarios" element={<AdminUsers />} />
              <Route path="/admin/integraciones" element={<AdminIntegrations />} />
              <Route path="/admin/reportes" element={<AdminReports />} />
            </Route>

            {/* Conductor */}
            <Route element={<ProtectedRoute allowedRoles={["conductor"]}><Outlet /></ProtectedRoute>}>
              <Route path="/conductor" element={<DriverDashboard />} />
              <Route path="/conductor/ruta" element={<DriverRoute />} />
              <Route path="/conductor/rutas-tarifas" element={<DriverRoutesManage />} />
              <Route path="/conductor/historial" element={<DriverHistory />} />
              <Route path="/conductor/perfil" element={<DriverProfile />} />
              <Route path="/conductor/calificaciones" element={<DriverRatings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
